const Features = {
  CHAT: 'CHAT',
  WORKOUT_VIDEO_FEEDBACK: 'WORKOUT_VIDEO_FEEDBACK',
  CHECK_IN_NOTIFICATION: 'CHECK_IN_NOTIFICATION',
  NUTRITION_PLAN: 'NUTRITION_PLAN',
  AI_FRIEND: 'AI_FRIEND',
};

// Challenge products only support a meal plan — mirrors the server-side
// `buildChallengeProductData` which enables NUTRITION_PLAN and nothing else.
// Drives which feature checkboxes stay enabled when creating a challenge product.
const CHALLENGE_SUPPORTED_FEATURES = [Features.NUTRITION_PLAN];

/**
 * Check if a product has a given feature enabled based on the product id or name
 * @param {string} product - The product id or name
 * @param {string} featureId - The feature id
 * @param {Array} products - The products array
 * @param {boolean} [defaultValue=false] - Value to return when the feature is not explicitly
 *   listed on the product. Defaults to false (strict: feature must be opted in).
 * @returns {boolean} - True if the product has the feature enabled, false otherwise
 */
const isProductHasEnabledGivenFeature = (product, featureId, products, defaultValue = false) => {
  const productFind = products.find((p) => p.id === product) || products.find((p) => p.name === product);
  return !!productFind?.isFeatureEnabled(featureId, defaultValue);
};

export {
  Features,
  CHALLENGE_SUPPORTED_FEATURES,
  isProductHasEnabledGivenFeature,
};
